import {
  InteractiveContainer,
  InteractiveContainerNativeProps,
} from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC, forwardRef, ReactNode } from "react";

interface TicketDetailItemProps
  extends Omit<InteractiveContainerNativeProps, "content" | "children"> {
  label: string;
  content: ReactNode;
  isInteractive?: boolean;
  isActive?: boolean;
  errorMessage?: string;
  className?: string;
}

export const TicketDetailItem = forwardRef<
  HTMLDivElement,
  TicketDetailItemProps
>(
  (
    {
      label,
      content,
      isInteractive,
      isActive,
      errorMessage,
      className,
      ...props
    },
    ref
  ) => {
    const stateClassName: string = (() => {
      if (!isInteractive) return "";
      if (errorMessage) return "bg-tertiary/5";
      if (isActive) return "bg-grey-100";
      return "hover:bg-grey-100";
    })();

    return (
      <InteractiveContainer
        ref={ref}
        isDisabled={!isInteractive}
        isTextSelectable={!isInteractive}
        className={cx(
          "flex h-[46px] w-full shrink-0 items-center gap-2 overflow-hidden rounded-xl bg-white px-3 transition-colors",
          stateClassName,
          className
        )}
        {...props}
      >
        <span className="w-[100px] shrink-0 truncate font-primary text-xs leading-[1.4] tracking-[0.12px] text-dark-700">
          {label}:
        </span>
        <div className="flex min-w-0 flex-1 items-center gap-2">{content}</div>
        {errorMessage && (
          <span className="text-xs leading-[150%] font-normal text-tertiary-700">
            {errorMessage}
          </span>
        )}
      </InteractiveContainer>
    );
  }
);

interface TicketDetailItemTextProps {
  text: string;
  startSlot?: ReactNode;
}

export const TicketDetailItemText: FC<TicketDetailItemTextProps> = ({
  text,
  startSlot,
}) => (
  <div className="flex items-center gap-2 overflow-hidden">
    {startSlot}
    <span className="truncate text-[13px] leading-[1.4] font-normal text-dark">
      {text}
    </span>
  </div>
);

export const TicketDetailItemPlaceholder: FC = () => (
  <span className="text-[13px] leading-[1.4] font-normal text-[#707577]">
    Select
  </span>
);
